import request from "@/util/request";

export function Enroll_GetList(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetList",
    method: "get",
    params,
  });
}
export function Enroll_GetClassifys(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetClassifys",
    method: "get",
    params,
  });
}
export function Enroll_GetDetail(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetDetail",
    method: "get",
    params,
  });
}

export function Enroll_GetFileds(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetFileds",
    method: "get",
    params,
  });
}
export function Enroll_UserSubEnroll(data) {
  return request({
    url: "/pc/Enroll/Enroll_UserSubEnroll",
    method: "post",
    data,
  });
}
